module.exports = __webpack_public_path__ + "static/media/foilRosegold.60a9f6f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/foilRosegold.svg
// module id = 734
// module chunks = 49